import { render, staticRenderFns } from "./OrderFabricYarnTypeTable.vue?vue&type=template&id=0d46c157&"
import script from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricYarnTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderFabricYarnTypeTable.vue?vue&type=style&index=0&id=0d46c157&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports